import { camelToSpaces } from "@permutation-city/common";
import {
  formatEther,
  formatPrice,
  getObjectImageUrl,
  objectTypes,
} from "@permutation-city/common";
import { BarLoader, TableWithColumns } from "@permutation-city/ui";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useIncentivesQuery } from "../../queries/useIncentivesQuery";

export function IncentivesTable() {
  const navigate = useNavigate();
  const { data: incentives, isLoading } = useIncentivesQuery();
  const formattedIncentives = incentives?.map((incentive) => ({
    ...incentive,
    id: incentive.objectId.toString(),
    name: {
      value: camelToSpaces(objectTypes[incentive.objectId].name).toUpperCase(),
      icon: getObjectImageUrl(incentive.objectId),
    },
    tokenAmount: formatPrice({ price: incentive.tokenAmount, decimals: 0 }),
    reputationAmount: formatEther(incentive.reputationAmount),
  }));

  useEffect(() => {
    if (!isLoading && incentives?.length === 1) {
      navigate({ to: `/incentive/${incentives[0].objectId}` });
    }
  }, [incentives, isLoading, navigate]);

  if (isLoading) {
    return <BarLoader intervalRate={100} />;
  }

  if (!isLoading && !formattedIncentives?.length) {
    return (
      <div className="uppercase">
        <p>No incentives found</p>
      </div>
    );
  }

  return (
    <TableWithColumns
      columns={[
        {
          name: "Name",
          key: "name",
        },
        {
          name: "Token reward",
          key: "tokenAmount",
        },
        {
          name: "Reputation reward",
          key: "reputationAmount",
        },
      ]}
      data={formattedIncentives}
      onClick={(item) => {
        navigate({
          to: `/incentive/${item.id}`,
        });
      }}
      loading={isLoading}
      searchable
    />
  );
}
